export default "__VITE_ASSET__1857bafa__"